<template>
  <div class="main-page webview-page">
    <Menus
      :title="title"
      :home=true
    />
    <div class="container-flex">
      <iframe
        ref="iframe"
        :src="url"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import Menus from '../components/Menu'

export default {
  components: {
    Menus
  },
  data () {
    return {
      title: '',
      url: ''
    }
  },
  mounted () {
    this.title = this.$route.query.title || ''
    this.url = this.$route.hash ? this.$route.query.url + this.$route.hash : this.$route.query.url || ''
    this.$loading.show()
    this.$refs.iframe.onload = () => {
      this.$loading.hide()
    }
  },
  beforeDestroy () {
    this.$loading.hide()
  }
}
</script>

<style lang="stylus" scoped>
iframe
  width 100%
  height 100%
</style>
